import metamaskLogo from './img/Metamasklogo.png';

import React from 'react';
import { Link } from "react-router-dom";
import { properties } from './properties';
import i18n from './I18N/I18n.js'; 
import LanguageSelector from './LanguageSelector';
import Cookies from 'js-cookie';



const NavBar = ({ mail, bearer, logout, cambiarIdioma }) => {


  const manejarCambioIdioma = (event) => {
    cambiarIdioma(event.target.value); // Llama a la función pasada como prop
  };

  if (typeof mail !== properties.noMailValue) {
    return (
      <nav className="custom-navbar">
      <Link to="/listaEmpresas" className="custom-navbar-item">
        {i18n.t('inicio')}
      </Link>
    
      <Link to="/changePass" className="custom-navbar-item">
        {i18n.t('ChangePass')}
      </Link>
    
      <LanguageSelector cambiarIdioma={cambiarIdioma} idioma = {Cookies.get('idiomaPreferido')} />
      
      <button type="button" className="custom-navbar-item custom-button" onClick={logout}>
        {i18n.t('LogOut')}
      </button>
    </nav>
    );
  } else {
    return (
      <nav className="custom-navbar">
      <Link to="/listaEmpresas" className="custom-navbar-item">
        {i18n.t('inicio')}
      </Link>
    
      

      <LanguageSelector cambiarIdioma={cambiarIdioma} idioma = {Cookies.get('idiomaPreferido')} />
      
      <button type="button" className="custom-navbar-item custom-button" onClick={logout}>
        {i18n.t('LogOut')}
      </button>
    </nav>
    );
  }
}
export default NavBar;
